export default function (instance) {
  return {
    getItemsBySearchQuery: (payload) => instance.post("api/search", payload),
  };
}
